import { defineTool } from '@/shell/tool';

/** Image/Video Gen: Vibes' generator in a frame (Flutter's `vibes` embed). */
export default defineTool({
  id: 'vibes-image-video-gen',
  title: 'Image/Video Gen',
  summary: "Vibes' image and video generator, in a frame.",
  section: 'vibes',
  order: 10,
  icon: 'image',
  owner: '@Drabu',
  permission: 'vibes-image-video-gen:use',
  routes: () => import('./ImageVideoGenPage'),
});
